var avatarFallback = 'fx_2d2fb1e5_cp0sj71';
var avatarFallbackBackground = 'var(--fx_2d2fb1e5_cp0sj70)';

export { avatarFallback, avatarFallbackBackground };
//# sourceMappingURL=fallback.vanilla.mjs.map
